import { defineNuxtPlugin, useRuntimeConfig } from "#imports";
import { createPlausibleTracker } from "@barbapapazes/plausible-tracker";
export default defineNuxtPlugin({
  name: "plausible",
  setup() {
    const options = useRuntimeConfig().public.plausible;
    if (!options.enabled) {
      return;
    }
    const plausible = createPlausibleTracker({
      ...options,
      logIgnored: options.logIgnoredEvents,
      domain: options.domain || window.location.hostname
    });
    return {
      provide: {
        plausible
      }
    };
  }
});
